module.exports = __webpack_public_path__ + "img/collection-memoireRingsColored@2x.ec36d3f.jpg";